import * as types from '../actions/action-types';

export const initialState = true;

const useDeliveryAddressForBillingReducer = (state = initialState, action) => {
  if (action.type === types.USE_DELIVERY_ADDRESS_FOR_BILLING) {
    return action.isUseDeliveryAddressForBilling;
  }
  return state;
};

export default useDeliveryAddressForBillingReducer;
